import React from "react";
import { Button } from "../ui/button";

const TherapistDirectory = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Browse 100+ therapists in Toronto
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Find a therapist who speaks your language and understands your background. Filter by language, specialty, and more.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-10">
          <a href="/therapist_directory?language=Urdu" className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">Urdu</a>
          <a href="/therapist_directory?language=Hindi" className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">Hindi</a>
          <a href="/therapist_directory?language=Arabic" className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">Arabic</a>
          <a href="/therapist_directory?language=Mandarin" className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">Mandarin</a>
          <a href="/therapist_directory?language=Punjabi" className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">Punjabi</a>
          <a href="/therapist_directory?language=Spanish" className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">Spanish</a>
          <a href="/therapist_directory?language=Somali" className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">Somali</a>
          <a href="/therapist_directory?language=Tamil" className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">Tamil</a>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="/therapist_directory">
            <Button variant="secondary" className="rounded-full text-white px-8 py-6 h-auto text-lg">
              Browse All Therapists
            </Button>
          </a>
          <a href="/intake_request_without_quiz/new">
            <Button variant="outline" className="rounded-full px-8 py-6 h-auto text-lg">
              Get Matched For Me
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TherapistDirectory;
